import { createContext, useContext, useState, type ReactNode } from "react";

interface AdminEditContextValue {
  isEditMode: boolean;
  toggleEditMode: () => void;
}

const AdminEditContext = createContext<AdminEditContextValue | null>(null);

export function AdminEditProvider({ children }: { children: ReactNode }) {
  const [isEditMode, setIsEditMode] = useState(false);

  const toggleEditMode = () => setIsEditMode((prev) => !prev);

  return (
    <AdminEditContext.Provider value={{ isEditMode, toggleEditMode }}>
      {children}
    </AdminEditContext.Provider>
  );
}

export function useAdminEdit() {
  const ctx = useContext(AdminEditContext);
  if (!ctx) throw new Error("useAdminEdit must be used within AdminEditProvider");
  return ctx;
}
